import { render, staticRenderFns } from "./UsersSelect.vue?vue&type=template&id=2bd642ab&scoped=true"
import script from "./UsersSelect.vue?vue&type=script&lang=ts"
export * from "./UsersSelect.vue?vue&type=script&lang=ts"
import style0 from "./UsersSelect.vue?vue&type=style&index=0&id=2bd642ab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd642ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd642ab')) {
      api.createRecord('2bd642ab', component.options)
    } else {
      api.reload('2bd642ab', component.options)
    }
    module.hot.accept("./UsersSelect.vue?vue&type=template&id=2bd642ab&scoped=true", function () {
      api.rerender('2bd642ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/UsersSelect.vue"
export default component.exports